export default __webpack_public_path__ + "static/media/Divertical2.507abf3a.webp";